import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../Static/PHPStatic/Titlebar.css';

const TitleBar = ({ data }) => {
    const { pathname } = useLocation();

    return (
        <div className="content">
            <div className="title-style">
                {data.map((item, index) => (
                    <Link to={item.path} className="title-name-link" key={index} style={{ textDecoration: 'none' }}>
                        <div className={`title-name ${item.path === pathname ? 'active' : ''}`}>
                            {item.title}
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default TitleBar;
